import type { AnyShippingMethod, CheckoutV2ConfigurationBuilder } from "@jti/commerce";

import { DEFAULT_AT_HOME_SHIPPING_METHOD } from "@checkout-v2/shared";

export const prepareShippingMethods = (
  checkoutV2Configuration: CheckoutV2ConfigurationBuilder
): AnyShippingMethod[] => {
  return checkoutV2Configuration?.shippingMethods && checkoutV2Configuration.shippingMethods.length > 0
    ? checkoutV2Configuration.shippingMethods
    : [DEFAULT_AT_HOME_SHIPPING_METHOD];
};
